import { createFileRoute } from "@tanstack/react-router";
import { PortalPage } from "@/components/portal/PortalPage";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/portal/descartados")({
  head: () =>
    buildSeo({
      title: "Descartados · Bizaclia",
      description: "Locales que has descartado en tu búsqueda en Bizaclia.",
      path: "/portal/descartados",
      noindex: true,
    }),
  component: () => <PortalPage segments={[]} mode="descartados" />,
});
